import { useQuery } from '@tanstack/react-query'
import { getDirectoryPlumbersForTown } from '../../lib/api'
import { buildPlumberHref } from '../../lib/plumberPins'
import { DirectoryPlumberCard } from './DirectoryPlumberCard'

/** "Other plumbers in {town}" — internal cross-links between profiles in the same
 *  town, so each profile has more incoming links (and users can compare options). */
export function OtherPlumbers({ basePath, countrySlug, countySlug, townSlug, townLabel, excludeSlug }: {
  basePath: string
  countrySlug: string
  countySlug: string
  townSlug: string
  townLabel: string
  excludeSlug?: string
}) {
  const { data } = useQuery({
    queryKey: ['directory', 'other-plumbers', countrySlug, countySlug, townSlug],
    queryFn: () => getDirectoryPlumbersForTown(countrySlug, countySlug, townSlug, undefined, undefined, undefined, { skip: 0, limit: 8 }, {}),
    enabled: !!(countrySlug && countySlug && townSlug),
    staleTime: 5 * 60 * 1000,
  })

  const ctx = { basePath, countrySlug, countySlug, townSlug }
  const others = (data?.plumbers ?? []).filter(p => p.directorySlug !== excludeSlug).slice(0, 4)
  if (others.length === 0) return null

  return (
    <section className="mt-10">
      <h2 className="text-lg font-bold text-gray-900 mb-3">Other plumbers in {townLabel}</h2>
      <div className="grid gap-3 sm:grid-cols-2">
        {others.map(p => <DirectoryPlumberCard key={p._id} plumber={p} href={buildPlumberHref(p, ctx)} />)}
      </div>
    </section>
  )
}
